import script from "./DynamicHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicHeader.vue?vue&type=style&index=0&id=32248a88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32248a88"]])

export default __exports__